module.exports = __webpack_public_path__ + "img/img17.3476e303.svg";